import _implicitStylesheets from "./pageButtons.css";

import _implicitScopedStylesheets from "./pageButtons.scoped.css?scoped=true";

import _lightningButtonIcon from "lightning/buttonIcon";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6} = $ctx;
  return [api_element("div", {
    classMap: {
      "pageButtons": true
    },
    key: 0
  }, [!$cmp.hidePageNavigation ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    styleDecls: [["--slds-c-icon-color-foreground", "white", false], ["--slds-c-button-text-color-hover", "white", false]],
    props: {
      "variant": "container",
      "iconName": "utility:jump_to_left",
      "alternativeText": "First",
      "title": "First"
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.displayFirstPage))
    }
  }, []) : null, !$cmp.hidePageNavigation ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    styleDecls: [["--slds-c-icon-color-foreground", "white", false], ["--slds-c-button-text-color-hover", "white", false]],
    props: {
      "variant": "container",
      "iconName": "utility:left",
      "alternativeText": "Previous",
      "title": "Previous"
    },
    key: 2,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.displayPreviousPage))
    }
  }, []) : null, $cmp.showThumbnailsButton ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    styleDecls: [["--slds-c-icon-color-foreground", "white", false], ["--slds-c-button-text-color-hover", "white", false]],
    props: {
      "iconName": "utility:side_list",
      "variant": "container",
      "size": "large"
    },
    key: 3,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleToggleThumbnails))
    }
  }, []) : null, api_element("span", {
    classMap: {
      "pdfTitle": true
    },
    key: 4
  }, [!$cmp.hideSearch ? api_element("input", {
    styleDecls: [["width", "40vw", false], ["border", "1px solid black", false], ["margin-top", "6.5px", false], ["color", "black", false]],
    classMap: {
      "search-pdf-text": true
    },
    attrs: {
      "type": "text"
    },
    key: 5
  }, []) : null, !$cmp.hideSearch ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    styleDecls: [["--slds-c-icon-color-foreground", "white", false], ["--slds-c-button-text-color-hover", "white", false]],
    props: {
      "variant": "container",
      "iconName": "utility:search",
      "alternativeText": "Search",
      "title": "Search"
    },
    key: 6,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.searchPdf))
    }
  }, []) : null]), api_element("input", {
    classMap: {
      "slds-input": true,
      "pageNumberInput": true,
      "slds-p-around_none": true,
      "displayNone": true
    },
    attrs: {
      "type": "text"
    },
    key: 7,
    on: {
      "input": _m4 || ($ctx._m4 = api_bind($cmp.pageNumberChange))
    }
  }, []), !$cmp.hidePageNavigation ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    styleDecls: [["--slds-c-icon-color-foreground", "white", false], ["--slds-c-button-text-color-hover", "white", false]],
    props: {
      "variant": "container",
      "iconName": "utility:right",
      "alternativeText": "Next",
      "title": "Next"
    },
    key: 8,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.displayNextPage))
    }
  }, []) : null, !$cmp.hidePageNavigation ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    styleDecls: [["--slds-c-icon-color-foreground", "white", false], ["--slds-c-button-text-color-hover", "white", false]],
    props: {
      "variant": "container",
      "iconName": "utility:jump_to_right",
      "alternativeText": "Last",
      "title": "Last"
    },
    key: 9,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.displayLastPage))
    }
  }, []) : null])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-pageButtons_pageButtons"
